/* eslint-disable import/prefer-default-export */
import { has, isArray } from 'lodash'
import { ResourceInfo } from '@src/utils/resource.utils'

export const getValue = data => {
  if (isArray(data)) {
    const first = data[0] || {}
    return has(first, '@value') ? first['@value'] : data[0]
  } else {
    return has(data, '@value') ? data['@value'] : data
  }
}

export const getInfo = (valueMap: string) => {
  const info: ResourceInfo = (JSON.parse(valueMap || 'null') || [])[0] || {}
  const object = {} as ResourceInfo
  for (const key in info) {
    if ((key as keyof ResourceInfo) === 'ObjectCount') {
      object[key] = getValue(info[key])
    } else {
      object[key] = info[key]
    }
  }
  return object
}
